import React from 'react';
import ReactApexChart from "react-apexcharts";


const MyCharts = (props) => {
  const { flaw } = props;




  /* 
    !###### EXAMPLE FLAW ARRAY ############
    * [
    *  ['Delik', '2'] -> flaw name & flaw count
    * ]
  */



  // const [colors] = ['#BEE1E6', '#FDE2E4', '#CFBAF0', '#FBF8CC', '#797D62', '#D08C60','#F1DCA7', '#d3f8e2', '#d0b8ac', '#f27a7d', '#daf5fe', '#f6daca', '#aa4465', "#ac2b9e", "#71d35c", "#f0e8a1", "#429b4e", "#f58c19", "#637c8e", "#c31e3f", "#eb45b0", "#9f607b", "#24afef", "#f07fc5", "#3a7a89"  ]
  // const colors = ['#ffc107', '#9c27b0', '#673ab7', '#3f51b5', '#00bcd4', '#e81e63', '#009688', '#4caf50', "#f44336", '#e81e63' ];
  const palette = ["#f26a8d", "#CFBAF0", "#D08C60", "#e4c027", "#8241a3", "#7084c7", "#5e4f1a", "#cde6f2", "#3a7a89", "#71d35c", "#f0e8a1", "#429b4e", "#f58c19", "#637c8e", "#c31e3f", "#eb45b0", "#9f607b", "#24afef", "#f07fc5", "#3a7a89", "#779977", "#c0ff3e", "#9aff9a", "#ee977b", "#224f19", "#ab7c6c", "#bbdd7b", "#4876ff", "#87ceff", "#e0ffff", "#bbffff", "#008b8b", "#8fbc8f", "#98fb98", "#caff70", "#ffec8b", "#eeb4b4", "#ff8247", "#ffd39b", "#eed8ae", "#cd7054", "#f08080", "#cd0000", "#ff82ab", "#ee7ae9", "#eeaeee", "#b452cd", "#5d478b", "#ffe1ff", "#cdb5cd"];

  const colors = flaw.map(([, , code]) => {
    const idx = Number(code);
    return Number.isFinite(idx) && palette[idx] ? palette[idx] : palette[0];
  });

  const series = [ //data on the y-axis
    {
      name: "Hata Sayısı",
      data: flaw.map((item) => {
        return item[1] // return flaw counts as new array
      })
    }
  ];

  const options = { //data on the x-axis
    options: {
      chart: {
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 1500,
          animateGradually: {
            enabled: true,
            delay: 150
          }
        },
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const selectedDataIndex = config.dataPointIndex;
            const selectedData = flaw[selectedDataIndex];
            sessionStorage.setItem('flaw_type_code', selectedData[2]);  // flaw type code id
            window.location.href = '/report';
          }
        },
        type: 'bar',
        height: '50%',

      },
      plotOptions: {
        bar: {
          columnWidth: '40%',
          distributed: true,
          borderRadius: 2,
          cursor: 'pointer',
        },
      },
      dataLabels: {
        offsetY: -20,
        enabled: true,
        style: {
          colors: ['darkblue'],
        }
      },
      colors: colors,
      legend: {
        show: true
      },

      xaxis: {
        categories: flaw.map((item) => { return item[0] }), //  return flaw name as new array
        labels: {
          style: {
            fontSize: '12px',
          }
        },
      }
    }
  };

  return (
    <div>
      <ReactApexChart
        options={options.options}
        series={series}
        type="bar"
        width="100%"
        height={260}
      />
    </div>
  )
}

export default MyCharts;

